import Utils from "../../../../../shared/utils";

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/all-in-advance/fourth-section.svg")